/** /design/$screen: one of the fourteen screens; any other slug is not found. */
import { createFileRoute } from '@tanstack/react-router';
import { checkScreenParam } from '../../design/route-guards.js';
import { DesignScreenRoute } from '../../design/route-parts.js';

export const Route = createFileRoute('/design/$screen')({
  beforeLoad: checkScreenParam,
  component: DesignScreenRoute,
});
